import React from "react"
import { Helmet } from "react-helmet"

interface Iseo {
  lang?: string
  description?: string
  meta?: string
  title?: string
  image?: string
}

const SEO: React.FC<Iseo> = ({ description, lang, title, image }) => {
  const getImage = () => {
    if (lang === "lt") return require("../assets/LT.jpg")
    if (lang === "en") return require("../assets/EN.jpg")
    if (lang === "pl") return require("../assets/PL.jpg")

    return { default: "" }
  }

  const urlLink = "https://konstytucja3maja.gov.pl"

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `og:image`,
          content: `${urlLink}${getImage()?.default || ""}`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
        {
          name: `twitter:image`,
          content: `${urlLink}${getImage()?.default || ""}`,
        },
      ]}
    />
  )
}

export default SEO
